import React from 'react';
import './ModalComponents.css';
import { FaTimes } from 'react-icons/fa';

const ModalComponent = ({
  show,
  handleClose,
  title,
  children,
  footerButtons,
  size = "auto"
}) => {
  if (!show) return null;

  const defaultButtons = [
    {
      label: 'Cancel',
      variant: 'outline-secondary',
      onClick: handleClose
    },
    {
      label: 'Save',
      variant: 'primary',
      onClick: () => {
        console.log('Save clicked');
        handleClose();
      }
    }
  ];

  const buttons = footerButtons || defaultButtons;

  const getModalSizeClass = () => {
    switch (size) {
      case "sm": return "custom-modal-sm";
      case "md": return "custom-modal-md";
      case "md1": return "custom-modal-md1";
      case "lg": return "custom-modal-lg";
      case "xl": return "custom-modal-xl";
      case "full": return "custom-modal-fullscreen";
      case "auto": default: return "custom-modal-auto";
    }
  };

  return (
    <>
      <div
        className={`custom-backdrop ${show ? 'custom-show' : ''}`}
        onClick={handleClose}
      ></div>

      <div
        className={`custom-modal-wrapper ${show ? 'custom-show' : ''}`}
        style={{ display: show ? 'flex' : 'none' }}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="customModalTitle"
        aria-hidden={!show}
      >
        <div className={`custom-modal-dialog ${getModalSizeClass()}`}>
          <div className="modal-content custom-modal-content">

            <div className="custom-modal-header p-3">
              <h5 className="custom-modal-title" id="customModalTitle">
                {title}
              </h5>
              <button
                type="button"
                className="review-close-btn"
                aria-label="Close"
                onClick={handleClose}
              >
                <FaTimes />
              </button>
            </div>

            <div className="custom-modal-body scrollable-body">
              {children}
            </div>

            <div className="custom-modal-footer p-3">
              {buttons.map((button, index) => (
                <button
                  key={index}
                  type="button"
                  className={`btn custom-btn-${button.variant} btn-${button.variant} custom-btn`}
                  onClick={button.onClick}
                  disabled={button.disabled}  
                >
                  {button.label}
                </button>
              ))}
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default ModalComponent;
